'use client';

import React from 'react';

import { IframeBlockProps } from '../../_blocks/IframeBlockGraphQL/types';
import { Gutter } from '../Gutter';
import classes from './IframeBlock.module.scss';

export const IframeBlock: React.FC<{
  className?: string;
  iframeBlock: IframeBlockProps;
}> = ({
  className,
  iframeBlock,
}) => {
  const { src, customDesktopAspectRatio, desktopAspectRatioWidth, desktopAspectRatioHeight, customMobileAspectRatio, mobileAspectRatioWidth, mobileAspectRatioHeight } = iframeBlock;

  // Calculate desktop aspect ratio
  const desktopAspectRatio = customDesktopAspectRatio && desktopAspectRatioWidth && desktopAspectRatioHeight
    ? `${desktopAspectRatioWidth}/${desktopAspectRatioHeight}`
    : '886/469';

  // Calculate mobile aspect ratio
  const mobileAspectRatio = customMobileAspectRatio && mobileAspectRatioWidth && mobileAspectRatioHeight
    ? `${mobileAspectRatioWidth}/${mobileAspectRatioHeight}`
    : '360/576';

  return (
    <Gutter className={[className, classes.wrapper].filter(Boolean).join(' ')}>
      <span
        style={{
          '--desktop-aspect-ratio': desktopAspectRatio,
          '--mobile-aspect-ratio': mobileAspectRatio
        } as React.CSSProperties}
      >
        <div className={classes.iframeWrapper}>
          <iframe
            src={src || ''}
            title="Embedded content"
            allowFullScreen
            style={{ height: '100%', width: '100%', position: 'absolute' }}
            data-da-style="true"
          />
        </div>
      </span>
    </Gutter>
  );
};

export default IframeBlock;
